import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "./AuthContext.js";

/**
 * Route guard. On a desktop deployment `useAuth().status` is always
 * `"authenticated"` (see `AuthContext.tsx`), so this never redirects there —
 * the login screen is unreachable in practice, not just hidden.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status !== "authenticated") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
